<template>
    <qweGrid :gridId="gridId"
        @[gridEvent.initGrid]="initGrid">
    </qweGrid>
</template>

<script>
    import { loader } from "../../utils/loader"
    import { ResponseCode } from "../../common/constant"
    import { RouterMeta } from "../../route"
    import qweGrid from "../../components/Grid/GridItem.vue"
    import { GridEvent } from "../../components/Grid"
    

    let cssList = [
        "/Qwe.VueComponent/kendo/css/kendo.common-bootstrap.min.css",
        "/Qwe.VueComponent/kendo/css/kendo.bootstrap.min.css"
    ]

    cssList.forEach(x=>{
        loader.loadCss(x)
    });

    export default {
        data:function(){
            return {
                gridId:"",
                gridEvent:GridEvent,
                height:""
            }
        },

        components:{
            "qweGrid":qweGrid
        },

        created:function(){
            let self = this;
            self.gridId = self.$route.params.gridId
            this.$watch(
                ()=> this.$route.params.gridId,
                function(gridId, oldValue){
                    if(self.$route.meta.name == RouterMeta.grid.name){
                        self.gridId = self.$route.params.gridId
                    }
                }
            );
        },

        // mounted:function(){
        //     let grid = $(".grid")[0].offsetHeight;
        //     this.height = grid+"px";
        //     console.log(grid);
        // },

        methods:{
            initGrid:function(code, Response){
                switch (code){
                    case ResponseCode.Success:
                        break;
                    case ResponseCode.NotFound:
                        this.$router.push(RouterMeta.notFound.path);
                        break;
                    case ResponseCode.NetWorkError:
                        this.$router.push({name:RouterMeta.netWorkError.name,params:{ originUrl: this.$route.fullPath }});
                        break;
                    case ResponseCode.UnAuthoized:
                        this.$router.push(RouterMeta.unAuthoized.path);
                        break;
                    case ResponseCode.Error:
                        break;
                    default:
                        break;
                }
            }
        }
        
    }   
</script>

